import { render, staticRenderFns } from "./BnplApplicationFail.vue?vue&type=template&id=00cc0258&"
import script from "./BnplApplicationFail.vue?vue&type=script&lang=js&"
export * from "./BnplApplicationFail.vue?vue&type=script&lang=js&"
import style0 from "./BnplApplicationFail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports